export interface IBlockProps {
  dataPath: string
  pathWithElementID: string | undefined
  elements?: JSX.Element[]
  title?: string
  className?: string
  classNameBody?: string
  dataSchema?: any
  name: string
  wrapper?: string
  buttons?: JSX.Element[]
  footerData?: JSX.Element[]
  renderHeaderControl?: (blockState?: boolean) => JSX.Element[] | []
  isOpened?: boolean | null | undefined
  isParentDisabled?: boolean
  levelDeep?: number
  isViewOnly?: boolean
  element_id?: string
  inCard?: boolean
  isRuleActive?: boolean
}

export enum BlockModels {
  ADJUSTABLE_RANGE = 'adjustable_range',
  SYNC_SETTINGS = 'sync_settings',
}
